module.exports = __webpack_public_path__ + "static/media/Ο ΚΟΣΜΟΣ ΤΩΝ ΚΩΦΩΝ.bf3e05c8.mp4";